import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from "../../jo-components/misc/emptyState/emptyState";
import Message from "../../resale/seller/components/message";
import { TicketCard } from '../../jo-components/cards/ticketCard/ticketCard';

export default function AttendeesList({ config, onSubmit=()=>{} }) {
    const { t } = useTranslation();
    const messages = config['messages'];
    const attendees = config['attendees'];

    const _onSubmit = React.useCallback((item) => {
        onSubmit({
            data: {
                action: 'TicketMenuStep',
                payload: {
                    attendee_id: item.id
                }
            }
        })
    }, [onSubmit]);

    return (
        <div className={'wz-waiting-list'}>
            {messages?.length > 0 && messages?.map((message, index) => (
                <Message key={index} description={message.subtitle} {...message} />
            ))}
            {attendees?.length > 0 ? (
                attendees.map((ticket) => (
                    <TicketCard key={ticket.id} ticket={ticket} onSubmit={() => _onSubmit(ticket)} />
                ))
            ) : (
                <EmptyState
                    icon='group'
                    title={t('widget.empty.tickets.title')}
                    subtitle={t('widget.empty.tickets.subtitle')}
                />
            )}
        </div>
    );
}